import React from 'react';

import IMG_1 from '../../../Images/gallery/puma/img_1.png';
import IMG_2 from '../../../Images/gallery/puma/img_2.png';
import IMG_3 from '../../../Images/gallery/puma/img_3.png';
import IMG_4 from '../../../Images/gallery/puma/img_4.png';
import IMG_5 from '../../../Images/gallery/puma/img_5.png';
import IMG_6 from '../../../Images/gallery/puma/img_6.png';
import IMG_7 from '../../../Images/gallery/puma/img_7.png';
import IMG_8 from '../../../Images/gallery/puma/img_8.png';
import IMG_9 from '../../../Images/gallery/puma/img_9.png';
import IMG_10 from '../../../Images/gallery/puma/img_10.png';

export const Puma_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>PUMA</span>,
  },
];

export const Title_1 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CHIVAS: MANIFIESTO</span>,
  },
];

export const Title_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PHOTOGRAPHY</span>,
  },
];

export const Puma_Gallery = [
  {
    src: IMG_1,
    imgWidth: '50%',
  },
  {
    src: IMG_2,
    imgWidth: '50%',
  },
  {
    src: IMG_3,
    imgWidth: '50%',
  },
  {
    src: IMG_4,
    imgWidth: '50%',
  },
  {
    src: IMG_5,
    imgWidth: '33.333333333%',
  },
  {
    src: IMG_6,
    imgWidth: '33.333333333%',
  },
  {
    src: IMG_7,
    imgWidth: '33.333333333%',
  },
  {
    src: IMG_8,
    imgWidth: '50%',
  },
  {
    src: IMG_9,
    imgWidth: '50%',
  },
  {
    src: IMG_10,
    imgWidth: '100%',
  },
];
